import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";

function Form() {

    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const path = '/formscreenhelpconfigs/';
    const paths = {
        endpointSave: config.endpoints.backend + 'formscreenhelpconfigs/save',
        endpointGetById: config.endpoints.backend + 'formscreenhelpconfigs/getById',
        endpointGetAllFunctionalities: config.endpoints.backend + "formscreenhelpconfigs/getAllFunctionalities",
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Configuração de Ajuda",
        labelTitleEdit: "Editar Configuração de Ajuda",
        labelTitleView: 'Visualizar Configuração de Ajuda'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                {
                    name: 'core_application_functionality_id',
                    type: 'select',
                    label: 'Tela',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllFunctionalities,
                        label: 'functionality',
                        value: 'id',
                        params: {
                            filter: {
                                form_screen_help_config_id: id
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'config',
                    type: 'tiny',
                    label: 'Configuração',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
